"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = exports.Option = exports.Label = exports.Error = exports.Arrow = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _lodash = _interopRequireDefault(require("lodash"));
var _polished = require("polished");
var _styles = require("../../utils/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Label = _styledComponents.default.label`
  ${({
  $error,
  $disabled,
  theme
}) => (0, _styledComponents.css)`
    display: flex;
    flex-direction: column;
    color: ${theme.colors.error};
    font-size: ${theme.fonts.sizes.medium};
    gap: 0.6rem;
    width: 100%;

    ${!$error && (0, _styledComponents.css)`
      color: ${theme.colors.primaryDark};

      &:hover div {
        &::after {
          background-color: ${theme.colors.primaryDark};
        }
      }
    `}

    ${$disabled && (0, _styledComponents.css)`
      pointer-events: none;
      opacity: 0.4;
    `}

    &:has(select:active, select:focus) {
      font-weight: ${theme.fonts.weight.medium};
    }
  `}
`;
exports.Label = Label;
const Arrow = _styledComponents.default.div`
  ${({
  $error,
  theme
}) => (0, _styledComponents.css)`
    display: grid;
    grid-template-areas: 'select';
    align-items: center;

    &::after {
      content: '';
      clip-path: polygon(50% 100%, 0% 0%, 100% 0%);
      background-color: ${(0, _polished.lighten)(0.5, theme.colors.primaryDark)};
      grid-area: select;
      justify-self: end;
      margin-right: 1.2rem;
      height: 5px;
      width: 1rem;

      ${$error && (0, _styledComponents.css)`
        background-color: ${theme.colors.error};
      `}
    }

    ${!$error && (0, _styledComponents.css)`
      &:has(select:hover, select:focus)::after {
        background-color: ${theme.colors.primaryDark};
      }
    `}

    &:has(select:active):hover::after {
      clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    }
  `}
`;
exports.Arrow = Arrow;
const Select = _styledComponents.default.select`
  ${({
  $error,
  theme,
  value
}) => (0, _styledComponents.css)`
    grid-area: select;
    background: none;
    border-radius: ${theme.border.radius.default};
    border: 1px solid ${(0, _polished.lighten)(0.5, theme.colors.primaryDark)};
    color: ${theme.colors.primaryDark};
    font-size: ${theme.fonts.sizes.medium};
    outline: none;
    overflow: hidden;
    padding: 0.1rem 3.6rem 0.1rem 1.1rem;
    min-height: 4.4rem;
    text-overflow: ellipsis;
    width: 100%;

    ${_styles.appearanceNone}
    ${_styles.userSelectNone}

    ${_lodash.default.isEmpty(value) && (0, _styledComponents.css)`
      color: transparent;
    `}

    &:hover {
      border-color: ${theme.colors.primaryDark};
    }

    &:active, &:focus {
      border: 2px solid ${theme.colors.primaryDark};
      padding: 0rem 3.5rem 0rem 1rem;
    }

    ${$error && (0, _styledComponents.css)`
      border-color: ${(0, _polished.lighten)(0.2, theme.colors.error)};

      &:active, &:focus, &:hover {
        border-color: ${theme.colors.error};
      }
    `}
  `}
`;
exports.Select = Select;
const Option = _styledComponents.default.option`
  ${({
  theme
}) => (0, _styledComponents.css)`
    color: ${theme.colors.primaryDark};
    font-size: ${theme.fonts.sizes.medium};

    &:first-of-type {
      color: ${(0, _polished.lighten)(0.4, theme.colors.primaryDark)};
    }
  `}
`;
exports.Option = Option;
const Error = _styledComponents.default.p`
  ${({
  theme
}) => (0, _styledComponents.css)`
    color: ${theme.colors.error};
    font-size: ${theme.fonts.sizes.small};
  `}
`;
exports.Error = Error;